import { Navigate, useRoutes } from "react-router-dom";
// auth
import AuthGuard from "../auth/AuthGuard";
import MainLayout from "src/layouts/main";
import GuestGuard from "../auth/GuestGuard";
// layouts
import CompactLayout from "../layouts/compact";
import DashboardLayout from "../layouts/dashboard";
// config
import { PATH_AFTER_LOGIN } from "../config-global";
import { PATH_DASHBOARD } from "./paths";
//
import {
  // Auth
  LoginPage,
  SignUpPage,
  RegisterPage,

  // Dashboard: General
  GeneralAppPage,

  // Dashboard: Report
  GeneralReportPage,
  AccountingPage,
  AccountingCreatePage,
  AccountingEditPage,
  AccountingSettingsPage,
  JournalEntriesPage,
  JournalEntryCreatePage,
  JournalEntryEditPage,
  JournalEntryDetailPage,
  BusinessPartnerPage,
  BusinessPartnerCreatePage,
  BusinessPartnerEditPage,
  BusinessPartnerDetailPage,

  // Dashboard: Staff
  UserListPage,
  UserEditPage,
  UserCreatePage,

  // Dashboard: Menu
  MenuDisplayPage,
  CatalogCategoriesListPage,
  CatalogCategoryCreatePage,
  CatalogCategoryEditPage,
  CatalogProductsListPage,
  CatalogProductCreatePage,
  CatalogProductEditPage,
  CatalogChoiceGroupsListPage,
  CatalogChoiceGroupCreatePage,
  CatalogChoiceGroupEditPage,
  CatalogBomsListPage,
  CatalogBomCreatePage,
  CatalogBomEditPage,
  VenuesListPage,
  VenueCreatePage,
  VenueEditPage,
  VenueDetailPage,
  WarehousesListPage,
  WarehouseCreatePage,
  WarehouseEditPage,
  WarehouseDetailPage,
  SubscriptionsListPage,
  SubscriptionDetailPage,
  ItemCreatePage,
  ItemEditPage,

  // Dashboard: Category
  CategoryCreatePage,
  CategoryEditPage,

  // Dashboard: Customer
  CustomerListPage,
  CustomerEditPage,
  CustomerCreatePage,
  CustomerInfoPage,

  // Dashboard: Desigination
  DesiginationCreatePage,
  DesiginationEditPage,

  // Dashboard: PROMOTION
  FranchisePromotionsListPage,
  FranchisePromotionCreatePage,
  FranchisePromotionEditPage,

  // Dashboard: Settings
  SettingsCreatePage,
  UserAccountPage,

  // Dashboard: store
  StorePage,
  FranchiseThemePreviewPage,
  ThemeEditPage,

  // DASHBOARD: Pages
  PageCreatePage,
  PageEditPage,
  PageListPage,
  // Other
  Page500,
  Page403,
  Page404,
} from "./elements";
import PrivateRoute from "./PrivateRoute";
export default function Router() {
  return useRoutes([
    // Auth
    {
      path: "auth",
      children: [
        {
          path: "login",
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          ),
        },
        {
          path: "register",
          element: (
            <GuestGuard>
              <RegisterPage />
            </GuestGuard>
          ),
        },
        {
          path: "sign-up",
          element: (
            <GuestGuard>
              <SignUpPage />
            </GuestGuard>
          ),
        },
      ],
    },

    // Dashboard
    {
      path: "dashboard",
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        {
          path: "app",
          element: (
            <PrivateRoute
              component={GeneralAppPage}
              permission="canViewDashboard"
            />
          ),
        },
        {
          path: "report",
          element: (
            <PrivateRoute
              component={GeneralReportPage}
              permission="canAccessReports"
            />
          ),
        },
        {
          path: "accounting",
          element: <Navigate to="/dashboard/accounting/accounts/list" replace />,
        },
        {
          path: "accounting/accounts/list",
          element: <PrivateRoute component={AccountingPage} />,
        },
        {
          path: "accounting/accounts/new",
          element: <PrivateRoute component={AccountingCreatePage} />,
        },
        {
          path: "accounting/accounts/:id/edit",
          element: <PrivateRoute component={AccountingEditPage} />,
        },
        {
          path: "accounting/settings",
          element: <PrivateRoute component={AccountingSettingsPage} />,
        },
        {
          path: "accounting/journals/list",
          element: <PrivateRoute component={JournalEntriesPage} />,
        },
        {
          path: "accounting/journals/new",
          element: <PrivateRoute component={JournalEntryCreatePage} />,
        },
        {
          path: "accounting/journals/:id/edit",
          element: <PrivateRoute component={JournalEntryEditPage} />,
        },
        {
          path: "accounting/journals/:id/detail",
          element: <PrivateRoute component={JournalEntryDetailPage} />,
        },
        {
          path: "business-partner",
          element: <Navigate to="/dashboard/business-partner/vendors/list" replace />,
        },
        {
          path: "business-partner/vendors/list",
          element: (
            <PrivateRoute
              component={BusinessPartnerPage}
              partnerRole="vendor"
              title="Vendor Partners"
              createPath={PATH_DASHBOARD.businessPartner.vendorNew}
              editPath={PATH_DASHBOARD.businessPartner.vendorEdit}
              detailPath={PATH_DASHBOARD.businessPartner.vendorDetail}
            />
          ),
        },
        {
          path: "business-partner/vendors/new",
          element: (
            <PrivateRoute
              component={BusinessPartnerCreatePage}
              partnerRole="vendor"
              listPath={PATH_DASHBOARD.businessPartner.vendorList}
              title="Add Vendor Partner"
            />
          ),
        },
        {
          path: "business-partner/vendors/:id/edit",
          element: (
            <PrivateRoute
              component={BusinessPartnerEditPage}
              partnerRole="vendor"
              listPath={PATH_DASHBOARD.businessPartner.vendorList}
              title="Edit Vendor Partner"
            />
          ),
        },
        {
          path: "business-partner/vendors/:id/detail",
          element: (
            <PrivateRoute
              component={BusinessPartnerDetailPage}
              listPath={PATH_DASHBOARD.businessPartner.vendorList}
              editPath={PATH_DASHBOARD.businessPartner.vendorEdit}
              title="Vendor Partner Detail"
            />
          ),
        },
        {
          path: "business-partner/customers/list",
          element: (
            <PrivateRoute
              component={BusinessPartnerPage}
              partnerRole="customer"
              title="Customer Partners"
              createPath={PATH_DASHBOARD.businessPartner.customerNew}
              editPath={PATH_DASHBOARD.businessPartner.customerEdit}
              detailPath={PATH_DASHBOARD.businessPartner.customerDetail}
            />
          ),
        },
        {
          path: "business-partner/customers/new",
          element: (
            <PrivateRoute
              component={BusinessPartnerCreatePage}
              partnerRole="customer"
              listPath={PATH_DASHBOARD.businessPartner.customerList}
              title="Add Customer Partner"
            />
          ),
        },
        {
          path: "business-partner/customers/:id/edit",
          element: (
            <PrivateRoute
              component={BusinessPartnerEditPage}
              partnerRole="customer"
              listPath={PATH_DASHBOARD.businessPartner.customerList}
              title="Edit Customer Partner"
            />
          ),
        },
        {
          path: "business-partner/customers/:id/detail",
          element: (
            <PrivateRoute
              component={BusinessPartnerDetailPage}
              listPath={PATH_DASHBOARD.businessPartner.customerList}
              editPath={PATH_DASHBOARD.businessPartner.customerEdit}
              title="Customer Partner Detail"
            />
          ),
        },

        {
          path: "user",
          children: [
            {
              element: <Navigate to="/dashboard/user/profile" replace />,
              index: true,
            },
            { path: "list", element: <UserListPage /> },
            {
              path: "new",
              element: (
                <PrivateRoute
                  component={UserCreatePage}
                  permission="canAddStaffAndRoles"
                />
              ),
            },
            {
              path: ":id/edit",
              element: <UserEditPage />,
            },
            {
              path: ":id/replicate",
              element: <UserEditPage />,
            },
            {
              path: "account",
              element: (
                <PrivateRoute
                  component={UserAccountPage}
                  permission="canViewStaff"
                />
              ),
            },
          ],
        },

        {
          path: "menu",
          children: [
            {
              element: <Navigate to="/dashboard/menu/profile" replace />,
              index: true,
            },
            {
              path: "display",
              element: <MenuDisplayPage />,
            },
          ],
        },

        {
          path: "item",
          children: [
            {
              element: <Navigate to="/dashboard/item/profile" replace />,
              index: true,
            },
            { path: "new", element: <ItemCreatePage /> },
            { path: ":id/edit", element: <ItemEditPage /> },
            { path: ":id/replicate", element: <ItemEditPage /> },
          ],
        },
        {
          path: "category",
          children: [
            {
              element: <Navigate to="/dashboard/category/profile" replace />,
              index: true,
            },
            { path: "new", element: <CategoryCreatePage /> },
            { path: ":id/edit", element: <CategoryEditPage /> },
            { path: ":id/replicate", element: <CategoryEditPage /> },
          ],
        },
        {
          path: "catalog",
          children: [
            {
              element: <Navigate to="/dashboard/catalog/categories/list" replace />,
              index: true,
            },
            {
              path: "categories/list",
              element: <CatalogCategoriesListPage />,
            },
            {
              path: "categories/new",
              element: <CatalogCategoryCreatePage />,
            },
            {
              path: "categories/:id/edit",
              element: <CatalogCategoryEditPage />,
            },
            {
              path: "products/list",
              element: <CatalogProductsListPage />,
            },
            {
              path: "products/new",
              element: <CatalogProductCreatePage />,
            },
            {
              path: "products/:id/edit",
              element: <CatalogProductEditPage />,
            },
            {
              path: "choice-groups/list",
              element: <CatalogChoiceGroupsListPage />,
            },
            {
              path: "choice-groups/new",
              element: <CatalogChoiceGroupCreatePage />,
            },
            {
              path: "choice-groups/:id/edit",
              element: <CatalogChoiceGroupEditPage />,
            },
            {
              path: "bom/list",
              element: <CatalogBomsListPage />,
            },
            {
              path: "bom/new",
              element: <CatalogBomCreatePage />,
            },
            {
              path: "bom/:id/edit",
              element: <CatalogBomEditPage />,
            },
          ],
        },
        {
          path: "venues",
          children: [
            {
              element: <Navigate to="/dashboard/venues/list" replace />,
              index: true,
            },
            { path: "list", element: <VenuesListPage /> },
            { path: "new", element: <VenueCreatePage /> },
            { path: ":id/detail", element: <VenueDetailPage /> },
            { path: ":id/edit", element: <VenueEditPage /> },
          ],
        },
        {
          path: "warehouses",
          children: [
            {
              element: <Navigate to="/dashboard/warehouses/list" replace />,
              index: true,
            },
            { path: "list", element: <WarehousesListPage /> },
            { path: "new", element: <WarehouseCreatePage /> },
            { path: ":id/detail", element: <WarehouseDetailPage /> },
            { path: ":id/edit", element: <WarehouseEditPage /> },
          ],
        },
        {
          path: "subscriptions",
          children: [
            {
              element: <Navigate to="/dashboard/subscriptions/list" replace />,
              index: true,
            },
            { path: "list", element: <SubscriptionsListPage /> },
            { path: ":id/detail", element: <SubscriptionDetailPage /> },
          ],
        },
        {
          path: "customer",
          children: [
            {
              element: <Navigate to="/dashboard/customer/profile" replace />,
              index: true,
            },
            {
              path: "list",
              element: (
                <PrivateRoute
                  component={CustomerListPage}
                  permission="canViewVenueCustomers"
                />
              ),
            },
            { path: "new", element: <CustomerCreatePage /> },
            { path: ":id/edit", element: <CustomerEditPage /> },
            { path: ":id/profile", element: <CustomerInfoPage /> },
          ],
        },
        {
          path: "store",
          children: [
            {
              path: "themes",
              element: <StorePage />,
            },
            {
              path: "themes/Preview/:themeName",
              element: <FranchiseThemePreviewPage />,
            },

            {
              path: "themes/:themeName/edit",
              element: <ThemeEditPage />,
            },
          ],
        },

        {
          path: "page",
          children: [
            {
              element: <Navigate to="/dashboard/customer/profile" replace />,
              index: true,
            },
            {
              path: "list",
              element: <PageListPage />
            },
            { path: "new", element: <PageCreatePage /> },
            { path: ":id/edit", element: <PageEditPage /> },
            { path: ":id/profile", element: <CustomerInfoPage /> },
          ],
        },

        {
          path: "desigination",
          children: [
            {
              element: <Navigate to="/dashboard/user/account" replace />,
              index: true,
            },
            {
              path: "new",
              element: (
                <PrivateRoute
                  component={DesiginationCreatePage}
                  permission="canAddStaffAndRoles"
                />
              ),
            },
            {
              path: ":id/edit",
              element: (
                <PrivateRoute
                  component={DesiginationEditPage}
                  permission="canEditStaffDetails"
                />
              ),
            },
          ],
        },

        {
  path:
    "promotions",

  children: [
    {
      element: (
        <Navigate
          to="/dashboard/promotions/list"
          replace
        />
      ),

      index: true,
    },

    {
      path:
        "list",

      element: (
        <FranchisePromotionsListPage />
      ),
    },

    {
      path:
        "new",

      element: (
        <FranchisePromotionCreatePage />
      ),
    },

    {
      path:
        ":id/edit",

      element: (
        <FranchisePromotionEditPage />
      ),
    },
  ],
},

        {
          path: "settings",
          children: [
            {
              element: <Navigate to="/dashboard/settings/new" replace />,
              index: true,
            },
            { path: "new", element: <SettingsCreatePage /> },
          ],
        },
      ],
    },

    {
      element: <CompactLayout />,
      children: [
        { path: "500", element: <Page500 /> },
        { path: "404", element: <Page404 /> },
        { path: "403", element: <Page403 /> },
      ],
    },
    {
      element: <MainLayout />,
      children: [
        {
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          ),
          index: true,
        },
      ],
    },
    { path: "*", element: <Navigate to="/404" replace /> },
  ]);
}
